export const fireUserSignOutEvent = () => {
  const event = document.createEvent("Event") as any;
  event.data = null;
  event.initEvent("user_sign_out", true, true);
  document.body.dispatchEvent(event);
};
